import { sendDwh } from 'reactApp/utils/ga';

export const sendModalAnalytics = ({ action, label = '', ...restData }) => {
    sendDwh({
        eventCategory: 'modal',
        action,
        label,
        dwhData: {
            ...restData,
        },
    });
};
